import { render, staticRenderFns } from "./UpdateDialog.vue?vue&type=template&id=33609753&scoped=true&"
import script from "./UpdateDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDialog.vue?vue&type=style&index=0&id=33609753&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33609753",
  null
  
)

export default component.exports